import styled from "@emotion/styled";
import { Box } from "@otrium/core";

export const StyledCollectionsCoverContainer = styled(Box)<{
  minimizeHeightOnMobile: boolean;
}>`
  position: relative;
  width: 100%;
  aspect-ratio: 720 / 161;
  background: ${(props) => props.theme.colors.tone.silver};

  &.desktop {
    display: block;
  }

  &.mobile {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    aspect-ratio: 4 / 3;

    &.desktop {
      display: none;
    }

    &.mobile {
      display: block;
    }
  }

  :before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0.6;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
  }
`;
